
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { AiAssistantI18nModule } from '../../assets/i18n/ai-assistant-i18n.module';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
@Component({
  selector: 'ai-sticky-footer',
  imports: [
    RouterModule,
    MatCardModule,
    MatButtonModule,
    AiAssistantI18nModule,
    GalaxyStickyFooterModule,
    GalaxyBadgeModule
],
  templateUrl: './sticky-footer.component.html',
  styleUrl: './sticky-footer.component.scss',
})
export class StickyFooterComponent {
  @Output() public submitClick = new EventEmitter<void>();
  @Output() public cancelClick = new EventEmitter<void>();
  @Input() public cancelLink?: string;
  @Input() public disabled = false;
  @Input() public submitOverride?: string;
  @Input() public cancelOverride?: string;
  @Input() public hideCancel = false;
  @Input() public showUnsavedChangesIndicator = false;
}
